var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 0 28 28",
    id: "employee",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122B87",
    d: "M9.5 17A4.5 4.5 0 1 1 14 12.5 4.51 4.51 0 0 1 9.5 17zm0-7A2.5 2.5 0 1 0 12 12.5 2.5 2.5 0 0 0 9.5 10zM20.5 14A5.5 5.5 0 1 1 26 8.5 5.51 5.51 0 0 1 20.5 14zm0-9A3.5 3.5 0 1 0 24 8.5 3.5 3.5 0 0 0 20.5 5zM29 30H12a1 1 0 0 1 0-2H28V22.42a5.51 5.51 0 0 0-5.5-5.5h-4a5.5 5.5 0 0 0-5 3.26 1 1 0 1 1-1.82-.82 7.48 7.48 0 0 1 6.84-4.44h4a7.5 7.5 0 0 1 7.5 7.5V29A1 1 0 0 1 29 30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#122B87",
    d: "M16,30H3a1,1,0,0,1-1-1V25.5a7.5,7.5,0,0,1,15,0V29A1,1,0,0,1,16,30ZM4,28H15V25.5a5.5,5.5,0,0,0-11,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#122B87",
    d: "M7 27a1 1 0 0 1-1-1V24a1 1 0 0 1 2 0v2A1 1 0 0 1 7 27zM25 26.85a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2A1 1 0 0 1 25 26.85z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/EmployeeIcon.d2245f56bf1d2130dc9b6ba0968a38f5.svg";
export { ForwardRef as ReactComponent };